<template>
    <ContentCard :bg-color="bgColor" :link="url" :disabled="content.lock">
        <div class="row align-items-center">
            <div class="col-auto nch--content-color" :style="{'color': color.primary}">
                <i class="mdi mdi-36px mdi-poll-box"></i>
            </div>
            <div class="col ml-1" :class="content.lock ? 'disabled' : ''">
                <h4 v-if="content.lock" class="nch--content-color">{{content.translation.name}}</h4>
                <h4 v-else class="mb-0">
                    <a :href="url">{{content.translation.name}}</a>
                </h4>
            </div>
            <ContentLock
                class="mx-3"
                v-if="content.lock"
                :message="content.lock_message"
                :color="color.primary"
            />
        </div>
    </ContentCard>
</template>

<script>
import ContentCard from "../../Common/ContentCard";
import ContentLock from "../../ContentComponents/ContentLock";

export default {
    name: "TopicComponent",

    components: {
        ContentCard,
        ContentLock
    },

    props: {
        content: {
            type: Object,
            required: true
        },
        courseId: {
            type: Number
        },
        moduleId: {
            type: Number
        },
        bgColor: {
            type: String,
            default: "#ececec"
        },
        parentId: Number,
        submodules: Array
    },
    data() {
        return {
            url: null
        };
    },
    computed: {
        color() {
            return this.$store.getters.COLOR;
        },
        queryParam() {
            return this.submodules
                .map(sub => {
                    return `submodules%5B%5D=${sub}`;
                })
                .toString()
                .replace(",", "&");
        }
    },
    mounted() {
        this.url = `${this.courseId}`;
        if (this.moduleId) {
            this.url = `${this.url}/module/${this.parentId}/topic/${this.content.id}?${this.queryParam}`;
        } else {
            this.url = `${this.url}/topic/${this.content.id}`;
        }
    }
};
</script>

<style scoped>
h4 {
    margin: 0;
    padding: 0;
}
</style>